import api from '../api'

export const postBreeding = (params) => api.post('/admin/creations', params)

export const putBreeding = ({ id, ...params }) => api.put(`/admin/creations/${ id }`, params)

export const deleteBreeding = ({ id }) => api.delete(`/admin/creations/${ id }`)
